import { LEDGER_ENTRY_TYPE, APPLIED_PAYMENT_TYPES } from 'Data/payments.js'

export function getText(transaction) {
  switch (transaction.type) {
    case LEDGER_ENTRY_TYPE.CHARGE:
      return 'Charge'
    case LEDGER_ENTRY_TYPE.ADJUSTMENT:
      return 'Adjustment'
    case LEDGER_ENTRY_TYPE.TRANSFER_DEBT:
      return 'Transfer'
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN:
      return 'Payment Plan'
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN_ROLLBACK:
      return 'Payment Plan Rollback'
    case LEDGER_ENTRY_TYPE.APPLIED_PAYMENT:
      switch (transaction.applied_payment?.applied_type) {
        case APPLIED_PAYMENT_TYPES.TO_PAYMENT:
          return 'Transfer Credit'
        case APPLIED_PAYMENT_TYPES.REFUND:
          return 'Refund'
        case APPLIED_PAYMENT_TYPES.PAYMENT_CORRECTION:
          return 'Correction'
        case APPLIED_PAYMENT_TYPES.TO_RECEIVABLE:
          return 'Payment (Applied)'
        default:
          return 'Payment (Applied)'
      }
    case LEDGER_ENTRY_TYPE.UNAPPLIED_PAYMENT:
      return 'Payment (Unapplied)'
    case LEDGER_ENTRY_TYPE.PAYMENT:
      return 'Payment'
    case LEDGER_ENTRY_TYPE.NOTE:
      return 'General Note'
    default:
      return transaction.type
  }
}
